
import OptionInput from "../OptionInput";

const MatrixInputItemRow = props => {
  const { id: itemId, label: itemLabel } = props.item;
  const {
    fieldName,
    options,
    isChecked,
    onChange,
    maximumSelectableOptions,
    singleOptionSelection
  } = props;

  const selectedOptionsCount = options.filter(({ id: optionId }) =>
    isChecked({ itemId, optionId })
  ).length;

  const inputType = singleOptionSelection ? "radio" : "checkbox";
  const maxOptionsSelected = selectedOptionsCount >= maximumSelectableOptions;

  return (
    <tr className="matrix-input-item-row">
      <th className="matrix-input-row-heading">{itemLabel}</th>

      {options.map(({ id: optionId }) => {
        const name = `${fieldName}-${itemId}`;
        const option = { id: JSON.stringify({ itemId, optionId }) };
        const isOptionChecked = isChecked({ itemId, optionId });
        const disabled = !singleOptionSelection && !isOptionChecked && maxOptionsSelected;

        return (
          <td key={optionId} className="matrix-input-row-option">
            <OptionInput
              type={inputType}
              name={name}
              option={option}
              onChange={onChange}
              checked={isOptionChecked}
              disabled={disabled}
            />
          </td>
        );
      })}
    </tr>
  );
};

export default MatrixInputItemRow;
